import { memo, useRef, useMemo, useState, useEffect } from "react"
import { HStack, Input, Flex, VStack, Button, Stack, Container, SegmentGroup } from "@chakra-ui/react"
import { Box, Circle, Float, IconButton, Text, Heading } from "@chakra-ui/react"
import { InputGroup } from "@/components/ui/input-group"
import { LuSearch, LuShoppingCart, LuMessageCircle, LuScanEye, LuEyeClosed, LuEye } from "react-icons/lu"
import { useCart } from "contexts/cart"
import { useNavigate } from "react-router"
import { useApp } from "contexts/app";
import { CloseButton } from "components/ui/close-button"
import { Separator } from "@chakra-ui/react"
import ProductService from "@/services/product"
import _ from "lodash"

const SearchBox = () => {
    let navigate = useNavigate();
    const { cart } = useCart();
    const { showProductSearch, setShowProductSearch, showAddToCart } = useApp();

    const [productList, setProductList] = useState([]);
    useEffect(() => {
        // if (showProductSearch)
        //     searchProduct();
    }, [showProductSearch]);
    useEffect(()=>{
        searchProduct();
    },[])

    const onSeachFocus = async () => {
        // setFocusSearch(true);
        // const service = new ProductService();
        // var data = await service.list();
        // // console.log("data", data)
        // setProductSearchList(data)
    }

    const searchProduct = async (info) => {
        const service = new ProductService();
        var data = await service.list({ info }, ["id", "name"]);
        setProductList(data);
    }

    const searchDelay = useMemo(() => _.debounce(searchProduct, 500), []);

    const goToProductPage = (id) => {
        setShowProductSearch(false);
        navigate(`/product/${id}`)
    }



    return (
        <div style={{ marginTop: 0 }}>
        

            <VStack style={{ marginTop: 90, paddingBottom: 20 }}>

            {/* <SegmentGroup.Root defaultValue="React">
                <SegmentGroup.Indicator />
                <SegmentGroup.Items items={["Tất cả", "Mua gần đây"]} />
            </SegmentGroup.Root> */}


                <div style={{ width: "100%" }}>


                    {productList.map(p => {
                        return (
                            <div style={{ marginTop: 16 }}>
                                <div style={{ display: "flex" }}  >
                                    <div style={{ flex: 0.8, alignContent:"center" }} onClick={e => goToProductPage(p.id)} >
                                        {p.name}
                                    </div>



                                    <div style={{ flex: 0.2 }} >
                                        <HStack gap={4}>
                                            <Button variant={"ghost"} onClick={e => { showAddToCart(p.id) }}> <LuShoppingCart></LuShoppingCart></Button>
                                        </HStack>

                                    </div>

                                </div>


                                <div style={{ marginTop: 8 }}>

                                    <Separator></Separator>
                                </div>
                            </div>
                        )
                    })}
                </div>

            </VStack>
            <div style={{ position: "fixed", backgroundColor: "white", top: 0, left: 0, right: 0 }}>
                <Container maxW={"md"}>


                    <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-end", marginBottom: 12, }}>
                        <div style={{ flexGrow: 1 }}>
                            <Heading>Tìm kiếm sản phẩm </Heading>
                        </div>
                        <div>
                            <CloseButton onClick={e => setShowProductSearch(false)}></CloseButton>
                        </div>

                    </div>
                    <InputGroup endElement={<LuSearch />} style={{ width: "100%" }}>
                        <Input placeholder="Tên hoặc mã" onChange={e => searchDelay(e.target.value)} />
                    </InputGroup>
                </Container>

            </div>

        </div>
    )
}

export default memo(SearchBox)